import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import * as Sentry from '@sentry/vue'
// import VueAnalytics from 'vue-analytics'

// Vue.use(VueAnalytics, {
//   id: 'G-QZPN7XPRYJ',
// })
import VueGtag from 'vue-gtag'
import { version } from '../package.json'

Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GTAG },
})

Vue.config.productionTip = false

Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  },
})

Sentry.init({
  Vue,
  dsn: 'https://a2897da9c4238bc6a2abc3c5095106f2@o4506860727435264.ingest.us.sentry.io/4506876283912192',
  release: 'credito-digital@' + version,
  environment: process.env.NODE_ENV,
  debug: process.env.NODE_ENV === 'production' ? false : true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/credigital\.cajamorelia\.com\.mx/,
  ],
  // Session Replay
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
})

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')
